/* @flow */
type PendingRole = {
  role: string,
  is_affirmed?: boolean,
  is_opted_in?: ?boolean,
  is_email_confirmed: boolean,
  official_email?: string,
};

export type Affiliation = {
  organization_id: number,
  roles: string[],
  pending_roles: PendingRole[],
  is_member: boolean,
  can_have_role_changed?: boolean,
};

export const hasPendingRole = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.length;
};

export const isPendingAdmin = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.find(pr => pr.role === 'admin');
};

export const isAdmin = (affiliation: Affiliation) => {
  return affiliation.roles.includes('admin');
};

export const isTeacherOrAdmin = (affiliation: Affiliation) => {
  return affiliation.roles.includes('teacher') || affiliation.roles.includes('admin');
};

export const needsOptIn = (affiliation: Affiliation) => {
  const roleNeedsOptIn = role => !role.is_opted_in;
  return !!affiliation.pending_roles.find(roleNeedsOptIn);
};

const roleNeedsEmailConf = role => !role.is_email_confirmed;

export const needsEmailConf = (affiliation: Affiliation) => {
  return !!affiliation.pending_roles.find(roleNeedsEmailConf);
};

export const getNeedsEmailConf = (affiliation: Affiliation) => {
  return affiliation.pending_roles.find(roleNeedsEmailConf);
};

export const isMember = (aff: Affiliation) => !!aff.is_member;

export const removeRole = (aff: Affiliation, role: string) => {
  return {
    ...aff,
    roles: (aff.roles.filter(r => r !== role): string[]),
  };
};
